import type { FC } from 'react'
import { PropsWithChildren } from 'react'
import { ActivationObjectContext } from '../constants'
import { ActivationObjectProviderProps } from '../types'

const ActivationObjectProviderView: FC<
    PropsWithChildren<ActivationObjectProviderProps>
> = ({ children, contextValue }) => {
    return (
        <ActivationObjectContext.Provider value={contextValue}>
            {children}
        </ActivationObjectContext.Provider>
    )
}
export default ActivationObjectProviderView
